import { useState, useEffect, useCallback } from 'react';
import { api, verificarSessao } from '../api';

export function useAuth() {
  const [logado, setLogado] = useState(!!localStorage.getItem('token'));
  const [sessaoMsg, setSessaoMsg] = useState(false);
  /** Badge: usuários pendentes (ADMIN) + contas a pagar + manutenções. */
  const [pendentes, setPendentes] = useState(0);

  const atualizarPendentes = useCallback(async () => {
    if (!localStorage.getItem('token')) return;
    try {
      let total = 0;
      const [contas, manutencoes] = await Promise.all([
        api.getCountAvisosContasAPagar(),
        api.getCountAvisosManutencaoMaquinario(),
      ]);
      total += contas?.count || 0;
      total += manutencoes?.count || 0;
      if (localStorage.getItem('role') === 'ADMIN') {
        const lista = await api.getUsuariosPendentes();
        total += lista?.length || 0;
      }
      setPendentes(total);
      window.dispatchEvent(new Event('notificacoes-atualizadas'));
    } catch {
      /* silencioso: badge não bloqueia o app */
    }
  }, []);

  const login = useCallback(() => {
    // Zera caches de sessão (status master, assinatura) para não herdar o
    // estado de uma conta usada antes no mesmo navegador.
    sessionStorage.clear();
    setLogado(true);
    setSessaoMsg(false);
    atualizarPendentes();
    window.history.replaceState(null, '', '/');
  }, [atualizarPendentes]);

  const logout = useCallback(() => {
    localStorage.clear();
    sessionStorage.clear();
    setLogado(false);
    setPendentes(0);
  }, []);

  useEffect(() => {
    const handler = () => { setLogado(false); setSessaoMsg(true); };
    window.addEventListener('sessao-expirada', handler);
    // Ao trocar de fazenda, o escopo muda: recomputa o badge de pendências.
    const onFazenda = () => atualizarPendentes();
    window.addEventListener('fazenda-ativa-alterada', onFazenda);

    if (logado) {
      verificarSessao();
      atualizarPendentes();
    }

    let interval = null;
    const iniciarInterval = () => {
      interval = setInterval(() => {
        if (logado && document.visibilityState === 'visible') {
          verificarSessao();
          atualizarPendentes();
        }
      }, 300000);
    };
    const pararInterval = () => { clearInterval(interval); interval = null; };
    const onVisibility = () => document.visibilityState === 'visible' ? iniciarInterval() : pararInterval();

    iniciarInterval();
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      window.removeEventListener('sessao-expirada', handler);
      window.removeEventListener('fazenda-ativa-alterada', onFazenda);
      document.removeEventListener('visibilitychange', onVisibility);
      clearInterval(interval);
    };
  }, [logado, atualizarPendentes]);

  return { logado, sessaoMsg, setSessaoMsg, pendentes, login, logout, atualizarPendentes };
}
